module.exports = __webpack_public_path__ + "img/kleisma2.36fcbd68.webp";